import CEDEMPbyLCSandPCforProduct from "pages/Evaluation/Product/filters/CEDEMPbyLCSandPCforProduct";
import shipmentTagForSubstanceByShipmentID
    from "pages/Evaluation/Product/generators/shipmentTagForSubstanceByShipmentID";
import {
    groupBy, mixtureSubstancesBySubstance, needsScenarioByShipment, shipmentsBySubstance
} from "selectors/generic";
import store from "source/store";
import theme from "source/theme";
import { PC } from "utils/constants/descriptorTypes";
import { lcsNames } from "utils/constants/lcsTypes";

// `product.product_raw_materials` - the composition rows of a product.
const compositionByProduct = groupBy("productRawMaterials", "product_id");

export default (product, evaluationScenario, lcs, allScenarios, shipmentsById, lcsById, rawMaterialsById) => {
    const flatScenarios = [];

    // The joins that replace what these payloads used to nest. Read from the
    // store rather than taken as arguments, the way the composition rows below
    // already are: this generator is reached through three report definitions
    // and the table above them, so every one of them would have to thread them.
    const state = store.getState();
    const descriptorsById = state.descriptors.models;
    const suppliersById = state.suppliers.models;
    const productRawMaterials = compositionByProduct(state)[product.id] || [];
    const mixturesOfSubstance = mixtureSubstancesBySubstance(state);
    const shipmentsOfSubstance = shipmentsBySubstance(state);
    const shipmentNeedsScenario = needsScenarioByShipment(state);

    const typesOfProducts = evaluationScenario.descriptors
        .filter(desc => desc.descriptor_type_id === PC)
        .map(desc => desc.code);

    const CEDEMPunderAnalaysis = CEDEMPbyLCSandPCforProduct(
        productRawMaterials, typesOfProducts, lcs, allScenarios, shipmentsById, mixturesOfSubstance, descriptorsById
    );

    const dangerousSubstancesIds = productRawMaterials
        .filter(s => s.contributes_to_hazard)
        .map(s => s.raw_material_id);

    let shipmentTagForSubstanceByShipmentIDdict = {};
    dangerousSubstancesIds.forEach(dsID => {
        shipmentTagForSubstanceByShipmentIDdict = {
            ...shipmentTagForSubstanceByShipmentIDdict,
            ...shipmentTagForSubstanceByShipmentID(
                dsID, rawMaterialsById, shipmentsOfSubstance, shipmentNeedsScenario, suppliersById
            )
        };
    });

    CEDEMPunderAnalaysis.forEach(scenario => {
        flatScenarios.push(
            [
                { text: scenario.code, colSpan: 1 },
                { text: lcsNames[lcsById[parseInt(scenario.lcs_id)].id], colSpan: 1 },
                { text: scenario.designation, colSpan: 1 },
                {
                    text: shipmentTagForSubstanceByShipmentIDdict[scenario.raw_material_supplier_id],
                    colSpan: 1
                },
                { text: scenario.notes, colSpan: 1 }
            ]
        );
    });

    // PDF Make Table partial object
    return {
        style: 'tableExample',
        layout: 'lightHorizontalLines',
        table: {
            headerRows: 0,
            widths: [80, 60, 60, 165, 100],
            body: [
                [
                    { text: "Codigo", colSpan: 1, fillColor: theme.palette.primary.main },
                    { text: "LCS", colSpan: 1, fillColor: theme.palette.primary.main },
                    { text: "Designação", colSpan: 1, fillColor: theme.palette.primary.main },
                    { text: "Fornecimento", colSpan: 1, fillColor: theme.palette.primary.main },
                    { text: "Notas", colSpan: 1, fillColor: theme.palette.primary.main }
                ],
                ...flatScenarios
            ]
        }
    };

};